import { OpenNewTabTargetType } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from 'react-native';
import { getParameters } from "../../configs/uri-config-utils";
import { QUERY_PARAMS } from "../../configs/constants";
export const helpAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const continueAction = async (action, _datastore, { navigate, navigateWithClear, openNewTab }) => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const ref = params?.[QUERY_PARAMS.REF];
    const utmSource = params?.utm_source;
    if (action?.payload?.showDownloadAppScreen) {
        openNewTab('whatsapp://send?phone=+919611749097&text=Hi,%20I%20need%20Volt%20Money%20app%20link%20to%20withdraw%20from%20my%20credit%20line', OpenNewTabTargetType.parent);
    }
    else {
        if (await AsyncStorage.getItem("application_id") !== null) {
            await navigate(ROUTE.PRE_DASHBOARD_SCREEN);
        }
        else {
            if (!await SharedPropsService.getAllowHome() || (utmSource === QUERY_PARAMS.PHONE_PE_FJ && params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */)) {
                await navigateWithClear(ROUTE.CREDIT_LOADING_SCREEN, { showDownloadAppScreen: true });
            }
            else {
                await navigate(ROUTE.DASHBOARD);
            }
        }
    }
};
export const onLoad = async (action, _datastore, { network, setDatastore, navigate }) => {
    let counter = 0;
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    const pollingResponse = setInterval(async () => {
        await network.get(`${api.creditPollingAPI}${applicationId}`, {
            headers: await getAppHeader(),
        }).then(async (response) => {
            if (response.status === 200) {
                if (response.data.creditApplicationApprovalStatus === "APPROVED") {
                    clearInterval(pollingResponse);
                    await setDatastore(ROUTE.CREDIT_LOADING_SCREEN, "creditDownload", {
                        isSuccessful: true,
                        availableCreditLimitAmount: response.data.creditLimit,
                        isPrimaryApplication: response?.data?.isPrimaryApplication,
                        counter: counter++,
                    });
                    await setDatastore(ROUTE.CREDIT_LOADING_SCREEN, "creditLoanDC", {
                        isSuccessful: true,
                        availableCreditLimitAmount: response.data.creditLimit,
                        isPrimaryApplication: response?.data?.isPrimaryApplication,
                        counter: counter++,
                    });
                }
                else {
                    await setDatastore(ROUTE.CREDIT_LOADING_SCREEN, "creditLoanDC", {
                        isSuccessful: false,
                        counter: counter++,
                    });
                }
            }
            else {
                clearInterval(pollingResponse);
            }
        });
    }, 3000);
};
